import {
  get_executesAt1z26sgmqnektw as get_executesAt,
  get_executedyhzhm61p8o8r as get_executed,
} from './ProjectTimerFields.mjs';
import {
  neqqjkp0prqcfuy as neq,
  eq1298m2cje971u as eq,
  xDataClassPathNotInSet2lprzz67ddi7c as xDataClassPathNotInSet,
} from '../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { andvtrcuje7baox as and } from '../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { Companion_getInstance1toq7c46z6qs1 as Companion_getInstance } from './enums.mjs';
import { get_inactiveStates2yk2ks5kh401v as get_inactiveStates } from './statePermissions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function running(_this__u8e3s4) {
  return and(neq(get_executesAt(_this__u8e3s4), null), eq(get_executed(_this__u8e3s4), null));
}
function isActive(_this__u8e3s4) {
  return xDataClassPathNotInSet(_this__u8e3s4, get_inactiveStates(Companion_getInstance()));
}
//region block: exports
export {
  isActive as isActive38ua0iq3hv7ll,
  running as running1fetq8eynjgzm,
};
//endregion

//# sourceMappingURL=conditions.mjs.map
